import { FC, useContext, useEffect } from 'react';
import { useCommon } from '../../../../../contexts/CommonContext';
import { useContentLocalizer } from '../../../../../hooks/useContentLocalizer';
import { localization } from '../../i18n/localization';
import { AdvancedDailyEngagedUserContainer } from '../../styles';
import AdvancedDailyEngagedUsersContext from '../../../../../contexts/Billing/AdvancedDailyEngagedUsersContext';
import AdvancedDailyEngagedUserMonthlyUsage from '../AdvancedDailyEngagedUserMonthlyUsage';

const MonthlyUsageComponent: FC = () => {
  const { dateToSearch, tenant } = useContext(AdvancedDailyEngagedUsersContext);
  const { setHeaderContent } = useCommon();
  const content = useContentLocalizer(localization);

  useEffect(() => {
    setHeaderContent({
      redirect: '/advanced-deu-consumption',
      text: content.formatString(content.header, tenant.info.name),
    });

    return () => setHeaderContent({ redirect: null });
  }, [dateToSearch]);

  return (
    <AdvancedDailyEngagedUserContainer>
      <AdvancedDailyEngagedUserMonthlyUsage isDetailedView />
    </AdvancedDailyEngagedUserContainer>
  );
};

export default MonthlyUsageComponent;
